import type PaperworkField from '@solvhealth/types/interfaces/PaperworkField';
import { isFieldDependencySatisfied } from './fieldDependencies';
import { PaperworkState } from '~/ducks/paperwork';
import { SectionPage } from '../interfaces';
import { isProviderGroupFieldDependencySatisfied } from '../providerGroups/util';

export const pageHasAvailableFields = (
  paperwork: PaperworkState,
  isProviderGroup: boolean,
  page?: SectionPage
) => {
  const isFieldDependencySatisfiedFn = isProviderGroup
    ? isProviderGroupFieldDependencySatisfied
    : isFieldDependencySatisfied;
  if (page?.fieldsRequiredToBeValid) {
    let fieldName;
    for (let i = 0; i < page?.fieldsRequiredToBeValid.length; i++) {
      fieldName = page?.fieldsRequiredToBeValid[i];
      if (!isFieldDependencySatisfiedFn(fieldName, paperwork)) {
        return false;
      }
    }
  }
  return page?.fieldNames.some(
    (fieldName: string) =>
      paperwork.standardFields &&
      paperwork.standardFields.find((field: PaperworkField) => field.field_name === fieldName) &&
      isFieldDependencySatisfiedFn(fieldName, paperwork)
  );
};
